import { delay } from '../draf.js';

const isSessionActive = (time) => (time - Math.ceil(Date.now() / 1000)) > 0;
const isLogin = (url) => url.indexOf('/login') === 0;

export default ({ router, store: { getters }, Vue }) => {
  router.beforeEach(async (to, from, next) => {
    let path = null;

    while (getters.appIsLoading) {
      await delay();
    }

    if (isSessionActive(getters.loggedIn.exp)) {
      if (isLogin(to.path)) {
        if (getters.isMotorista) {
          path = '/motorista'
        } else {
          path = '/welcome'
        }
      } else if (getters.isMotorista && ['/motorista', '/ocorrencia', '/editar-minha-conta'].indexOf(to.path) === -1) {
        path = '/motorista'
      } else if (!getters.isMotorista && ['/motorista', '/ocorrencia', '/editar-minha-conta'].indexOf(to.path) > -1) {
        path = '/welcome'
      }
    } else {
      if (to.path !== '' && !isLogin(to.path)) {
        path = '/login'
      }
    }

    if (path) next({ path })
    else next()
  })
}
